<template>
  <b-container fluid id="navbar">
    <b-row>
      <b-col v-bind:class="[$route.name === 'Classement' ? 'active_tab' : '']">
        <b-link class="nav_item" href="/challenge-maritima/">Classement</b-link>
      </b-col>
      <b-col v-bind:class="[$route.name === 'Courses' ? 'active_tab' : '']">
        <b-link class="nav_item" href="/challenge-maritima/courses">Courses</b-link>
      </b-col>
      <b-col v-bind:class="[$route.name === 'Reglement' ? 'active_tab' : '']">
        <b-link class="nav_item" href="/challenge-maritima/reglement">Réglement</b-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
